import { strengths } from "@/mocks/services";

export default function Strengths() {
  return (
    <section id="strength"className="bg-background-50 py-20 md:py-28">
       
      <div className="mx-auto max-w-7xl px-4 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <p className="text-xs tracking-[0.3em] uppercase text-accent-700 mb-4">
            OUR STRENGTHS
          </p>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-tight mb-4">
            私たちの強み
          </h2>
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
            即座かつ柔軟に判断・対応いたします。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
          <div className="md:col-span-5">
            
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-8 text-justify">
                安さと丁寧さ。私たちは、その両方が「なぜ実現できるのか」を、正直にお伝えできる清掃会社です。<br></br><br></br>
                また、同じ担当者が毎回清掃を行うことでお客様の好みを把握でき、時間外対応や特殊な清掃リクエストにも迅速に応じることが可能です。<br></br><br></br>
                信頼関係を重視するお客様に対して、高い満足度と安心感の提供を目指します。
            </p>
            <div className="inline-flex items-center gap-3 bg-primary-50 border border-primary-200 px-5 py-4 rounded-md">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-award-line text-lg"></i>
              </span>
              <div>
                <p className="text-xs text-foreground-600">同等条件・他社見積比較</p>
                <p className="font-heading text-lg text-primary-800">平均 10% 安い実績</p>
              </div>
            </div>
          </div>

          <div className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            {strengths.map((s, idx) => (
              <div
                key={s.title}
                className={`rounded-lg p-6 md:p-7 border ${
                  idx % 2 === 0
                    ? "bg-background-100 border-background-200"
                    : "bg-primary-900 border-primary-800 text-background-50"
                }`}
              >
                <div
                  className={`w-12 h-12 flex items-center justify-center rounded-md mb-4 ${
                    idx % 2 === 0
                      ? "bg-accent-100 text-accent-700"
                      : "bg-accent-500 text-background-50"
                  }`}
                >
                  <i className={`${s.icon} text-2xl`}></i>
                </div>
                <h3
                  className={`font-heading text-lg mb-2 ${
                    idx % 2 === 0 ? "text-foreground-950" : "text-background-50"
                  }`}
                >
                  {s.title}
                </h3>
                <p
                  className={`text-sm leading-relaxed text-justify ${
                    idx % 2 === 0 ? "text-foreground-700" : "text-background-200"
                  }`}
                >
                  {s.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}